import { nullable, struct } from 'io-ts/Decoder';

import { Id as CollaboratorType } from '../../../../job/collaborator/type/Id';
import { Id as JobId } from '../../../../job/Id';

export const Params = struct({
	jobId: JobId,
	collaboratorType: nullable(CollaboratorType),
});
